import React, { useCallback } from "react";

import cn from "classnames";
import { useIntl } from "react-intl";

import { FieldTeamVisibility } from "@mapmycustomers/shared/enum/FieldVisibility";
import Role from "@mapmycustomers/shared/types/Role";
import SchemaField from "@mapmycustomers/shared/types/schema/SchemaField";
import Team from "@mapmycustomers/shared/types/Team";

import RolesVisibilityList from "../RolesVisibilityList";

import messages from "./messages";
import styles from "./TeamItem.module.scss";

interface Props {
  calculatedField?: boolean;
  className?: string;
  disabledFieldVisibilities?: FieldTeamVisibility[];
  onChange?: (team: null | Team, value: Record<Role["id"], FieldTeamVisibility>) => void;
  phiEnabled?: boolean;
  schemaField?: SchemaField;
  team: null | Team;
  value?: Record<Role["id"], FieldTeamVisibility>;
}

const TeamItem: React.FC<Props> = ({
  calculatedField,
  className,
  disabledFieldVisibilities,
  onChange,
  phiEnabled,
  schemaField,
  team,
  value,
}) => {
  const intl = useIntl();

  const handleChange = useCallback(
    (value: Record<Role["id"], FieldTeamVisibility>) => {
      onChange?.(team, value);
    },
    [onChange, team]
  );

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.title}>{team ? team.name : intl.formatMessage(messages.noTeam)}</div>
      <RolesVisibilityList
        calculatedField={calculatedField}
        disabledFieldVisibilities={disabledFieldVisibilities}
        onChange={handleChange}
        phiEnabled={phiEnabled}
        schemaField={schemaField}
        value={value}
      />
    </div>
  );
};

export default TeamItem;
